import { createContext } from "react";

export const CreateOdeModalContext = createContext();
